///<reference path="../../../analytics/primolytics.service.ts"/>
import {Component, OnInit, Inject} from 'ng-metadata/core';
import {BrowseSearchBarService} from './browseSearchBar.service';
import {BrowseSearchService} from "../browseSearch.service";
import {STATE_NAMES} from '../../../primoExplore/primoExploreStates.module';
import {getVid} from "../../../appConfig/appConfigForward";
import {beacon, PrimolyticsService} from "../../../analytics/primolytics.service";
import {ChangeLangService} from "../../../infra/lang/changeLang.service";
import {MediaQueries} from "../../../infra/mediaQueries.service";
import {MappingTablesCache} from "../../../mappingTablesCache/mappingTablesCache.service";

const orderBy = require('lodash/orderBy');

@Component({
    selector: 'prm-browse-search-bar',
    templateUrl: 'components/search/browse/browseSearchBar/browse-search-bar.html',
})

export class PrmBrowseSearchBar implements OnInit {
    public searchState = STATE_NAMES.BROWSE_SEARCH;
    private focusOnSearchInput: boolean = false;
    private vid = getVid();


    constructor(private browseSearchBarService: BrowseSearchBarService,
                private browseSearchService: BrowseSearchService,
                private primolyticsService: PrimolyticsService,
                @Inject('$state') private $state: ng.ui.IStateService,
                @Inject('searchBoxIcons') private searchBoxIcons: Object[],
                private changeLangService: ChangeLangService,
                @Inject('$scope') private $scope: ng.IScope,
                @Inject('$element') private $element,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('$location') private $location: ng.ILocationService,

                private mediaQueries: MediaQueries,
                private mtCache:MappingTablesCache) {

        this.focusOnSearchInput = (this.mtCache.getTable(this.mtCache.tables.VIEW_PROPERTIES).filter((row) => row.source1 === this.vid && row.source2 === 'focus_on_search_input' && row.target === 'true').length === 1);

    }

    ngOnInit() {
        if (this.$state.params['docCount'] != null || this.isFullViweState()) {
            this.browseSearchBarService.scopesProgress = true;
            let promise = this.browseSearchBarService.getLinkScopes();
            // let self = this;

            promise.then((response) => {
                this.browseSearchBarService.scopesProgress = false;
                this.browseSearchBarService.scopes = orderBy(response.data, 'SourceCode5');
                this.browseSearchBarService.setSlectedScope()
                if (this.selectedScope === undefined) {
                    this.selectedScope = this.browseSearchBarService.scopes[0];
                }
            });
        }

        if (this.isFullViweState()){
            if (this.$location.search().browseQuery){ //This scenario should only happen when reaching fullview from person page
                this.searchBarInput = this.$location.search().browseQuery;
            }
        }

        this.$scope.$watch(() => this.searchBarInput, (newVal, oldVal) => {
            this.$timeout(() => {
                this.removeAriaLabel('md-input-container input');
            }, 400);
        });

        // Set autofocus to input search bar
        this.$timeout(() => {
            if (this.mediaQueries.gtmd && this.focusOnSearchInput) {
                let elem = document.querySelector('#searchBarBrowse');
                if (elem) {
                    elem.focus();
                }
            }
        }, 0);
    }

    get scopes() {
        return this.browseSearchBarService.scopes;
    }

    get selectedScope(): Object {
        return this.browseSearchBarService.selectedScope;
    }

    set selectedScope(newScope: Object) {
        this.browseSearchBarService.selectedScope = newScope;
    }

    public performSearch() {
        //this.browseSearchService.getSearchJson('BrowseSearch', this.searchBarInput,this.selectedScope['SourceCode1']);
        this.$state.go(this.searchState, {
            vid: getVid(), browseQuery: this.searchBarInput, browseScope: this.selectedScope['SourceCode1'],
            browseFirstTerm: null, innerPnxIndex: -1, numOfUsedTerms: -1, fn: "BrowseSearch"
        }, {reload: false});

        // Only for mobile -  This for auto-closing of the keyboard when the user clicks search from the mobile keyboard button
        if (!this.mediaQueries.gtmd) {
            document.getElementById("searchBarBrowse").blur();
        }
    }

    get searchBarInput(): string {
        return this.browseSearchBarService.searchBarInput;
    }

    set searchBarInput(newSearchInput: string) {
        this.browseSearchBarService.searchBarInput = newSearchInput;
    }

    private switchToLtrString() {
        return this.changeLangService.direction == 'rtl';
    }

    //this function remove aria-label from search edit field.
    private removeAriaLabel(str) {
        let searchEditField: [Element] = this.$element[0].querySelectorAll(str);
        for (let input of searchEditField) {
            input.removeAttribute('aria-label');
        }
    }

    private onClearSearchInput() {
        this.searchBarInput = undefined;
        document.querySelector('#searchBarBrowse').focus();
    }
    
    public isFullViweState () {
        return this.$state.current.name === STATE_NAMES.FULL_DISPLAY;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/browse/browseSearchBar/browseSearchBar.directive.ts